import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { format } from 'date-fns';
import config from '@/pathConfig';
import { batchUploadFile } from '@/api/commonApi.js';
import { saveReimburseCost, queryCost, submitReimburse } from '@/api/reimburse/reimburseApi.js';
export default {
  data: function data() {
    return {
      config: config,
      loading: false,
      options: [],
      // 级联选择数据
      userInfo: this.$hdk.userInfo.get(),
      cardTitle: '新建费用报销单',
      labelCol: {
        span: 8
      },
      wrapperCol: {
        span: 16
      },
      organPostId: [],
      formObject: {
        detail: {
          id: '',
          organPostId: [],
          typeId: '',
          cateId: 2,
          organId: '',
          postId: '',
          operator: this.$hdk.userInfo.get().userName,
          // 经办人
          reason: '',
          // 报销事项
          accountNumber: '',
          // 经办人开户账号
          accountOpening: '',
          // 开户行
          remarks: '',
          // 备注
          applyDate: '',
          // 报销日期
          totalAmount: '',
          // 报销金额小写
          totalAmountBig: '',
          // 报销金额大写
          attach: [] // 附件
        }
      },
      rules: {
        //organPostId: [{ required: true, message: '请选择所属组织及岗位' }],
        reason: [{
          required: true,
          message: '请输入报销事项'
        }, {
          max: 200,
          message: '字数超出限制200'
        }],
        accountNumber: [{
          required: true,
          message: '请输入经办人账号'
        }
        // { min: 12, max: 19, message: '账号长度是12~19个字符' },
        // { type: 'string', pattern: /^[0-9]*$/, message: '请输入数字' }
        ],
        accountOpening: [{
          required: true,
          message: '请输入开户行'
        }, {
          max: 50,
          message: '字数超出限制50'
        }],
        remarks: [{
          max: 500,
          message: '字数超出限制500'
        }],
        applyDate: [{
          required: true,
          message: '请选择报销日期'
        }],
        totalAmount: [{
          required: true,
          message: '请输入金额'
        }],
        totalAmountBig: [{
          required: true,
          message: '根据输入金额自动转换'
        }]
      },
      fileObj: []
    };
  },
  created: function created() {
    var _this = this;
    var $route = this.$route,
      userInfo = this.userInfo;
    // 级联数据处理
    this.options = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        typeId: item.typeId,
        children: item.postList
      };
    });

    // 查询费用详情
    if ($route.query.fillId) {
      this.cardTitle = '编辑费用报销单';
      queryCost($route.query.fillId).then(function (res) {
        var cost = res.data;
        _this.formObject = cost;
        _this.formObject.detail.organPostId = [cost.detail.organId, cost.detail.postId];
        _this.organPostId = [cost.detail.organId, cost.detail.postId];
        _this.fileObj = _.map(cost.detail.attach, function (item) {
          return {
            fileid: item.id,
            filename: item.fileName,
            filepath: item.filePath,
            uid: item.id,
            name: item.fileName,
            status: 'done',
            type: 1
          };
        });
      });
    }
    // queryTravel
  },
  methods: {
    saveDraft: function saveDraft() {
      var _this2 = this;
      var $refs = this.$refs,
        $set = this.$set,
        formObject = this.formObject,
        fileObj = this.fileObj,
        callSaveReimburseFill = this.callSaveReimburseFill;
      $refs.addForm.validate(function (valid) {
        if (valid) {
          // 上传附件
          if (fileObj.length > 0) {
            var newFileObj = _.map(fileObj, function (item) {
              if (item.type === 0) {
                return item;
              } else {
                return;
              }
            });
            // 去除为空的
            newFileObj = _.compact(newFileObj);
            _this2.formObject.detail.attach = _.remove(fileObj, function (n) {
              if (n.type === 1) {
                return n;
              }
            });

            // 判断处理后的附件是否为空,为空表示没有新上传附件
            if (newFileObj.length > 0) {
              batchUploadFile(newFileObj).then(function (res) {
                _.map(res.data.data, function (item) {
                  _this2.formObject.detail.attach.push({
                    filename: item.originalName,
                    filepath: item.filepath,
                    originalname: item.originalName
                  });
                });
                callSaveReimburseFill(1);
              });
            } else {
              callSaveReimburseFill(1);
            }
          } else {
            callSaveReimburseFill(1);
          }
        }
      });
    },
    /*
     * 调用存入草稿的接口
     */
    callSaveReimburseFill: function callSaveReimburseFill(flag) {
      var _this3 = this;
      var $set = this.$set,
        $message = this.$message,
        formObject = this.formObject,
        goBack = this.goBack,
        optionVal = this.optionVal;
      return new Promise(function (resolve, reject) {
        _this3.loading = true;
        if (!formObject.detail.id && formObject.detail.applyDate) {
          $set(formObject, 'applyDate', format(formObject.detail.applyDate._d, 'yyyy-MM-dd'));
        }
        saveReimburseCost(_objectSpread({}, formObject.detail)).then(function (res) {
          if (res.data.code == 200 && flag == 1) {
            $message.success('保存成功');
            goBack();
          } else if (res.data.code == 200 && flag == 0) {
            resolve(res.data.data);
          }
          _this3.loading = false;
        });
      });
    },
    submitReimburse: function submitReimburse() {
      var _this4 = this;
      var $refs = this.$refs,
        $confirm = this.$confirm,
        $message = this.$message,
        formObject = this.formObject,
        goBack = this.goBack,
        fileObj = this.fileObj,
        mySubmitReimburse = this.mySubmitReimburse;
      $refs.addForm.validate(function (valid) {
        if (valid) {
          _this4.loading = true;
          $confirm('确认提交吗?', '提示', {
            type: 'info',
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          }).then(function () {
            // 上传附件
            if (fileObj.length > 0) {
              var newFileObj = _.map(fileObj, function (item) {
                if (item.type === 0) {
                  return item;
                } else {
                  return;
                }
              });
              // 去除为空的
              newFileObj = _.compact(newFileObj);
              _this4.formObject.detail.attach = _.remove(fileObj, function (n) {
                if (n.type === 1) {
                  return n;
                }
              });

              // 判断处理后的附件是否为空,为空表示没有新上传附件
              if (newFileObj.length > 0) {
                batchUploadFile(newFileObj).then(function (res) {
                  _.map(res.data.data, function (item) {
                    _this4.formObject.detail.attach.push({
                      filename: item.originalName,
                      filepath: item.filepath,
                      originalname: item.originalName
                    });
                  });
                  mySubmitReimburse();
                });
              } else {
                mySubmitReimburse();
              }
            } else {
              mySubmitReimburse();
            }
          }).catch(function () {
            _this4.loading = false;
          });
        }
      });
    },
    mySubmitReimburse: function mySubmitReimburse() {
      var _this5 = this;
      var $message = this.$message,
        formObject = this.formObject,
        callSaveReimburseFill = this.callSaveReimburseFill,
        goBack = this.goBack;
      if (formObject.detail.id) {
        callSaveReimburseFill(0).then(function (res) {
          submitReimburse(formObject.detail.id).then(function (res) {
            if (res.data.code == 200) {
              $message.success('提交成功');
              goBack();
            }
            _this5.loading = false;
          });
        });
      } else {
        callSaveReimburseFill(0).then(function (res) {
          _this5.formObject.detail.id = res; // 赋值存为草稿的主键id用于提交
          submitReimburse(_this5.formObject.detail.id).then(function (res) {
            if (res.data.code == 200) {
              $message.success('提交成功');
              goBack();
            }
            _this5.loading = false;
          });
        });
      }
    },
    /**
     * 文件上传存值
     */
    actionUpload: function actionUpload(data) {
      var $message = this.$message,
        fileObj = this.fileObj;
      if (fileObj.length > 5) {
        $message.error('文件最多同时上传5个');
        return;
      }
      // 用于上传后回显及往文件对象存值
      this.fileObj.push({
        file: data.file,
        uid: data.file.uid,
        name: data.file.name,
        status: 'done',
        type: 0
      });
    },
    /**
     * 文件大小
     */
    beforeUpload: function beforeUpload(file) {
      var $message = this.$message;
      var isLt1M = file.size / 1024 / 1024 < 500;
      if (!isLt1M) {
        $message.error('最大只能上传500MB');
      }
      return isLt1M;
    },
    /**
     * 文件删除
     */
    delFile: function delFile(data) {
      var fileObj = this.fileObj;
      if (1 === fileObj.length) {
        this.fileObj = [];
        this.formObject.detail.attach = [];
      } else {
        var evens = _.remove(fileObj, function (n) {
          if (n.fileid != data.fileid) {
            return n;
          }
        });
        this.fileObj = evens;
        this.formObject.detail.attach = evens;
      }
    },
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value, option) {
      var $set = this.$set,
        formObject = this.formObject;
      // 组织岗位赋值
      if (option) {
        $set(formObject.detail, 'organId', value[0]);
        $set(formObject.detail, 'postId', value[1]);
        $set(formObject.detail, 'typeId', option[0].typeId);
      } else {
        $set(formObject.detail, 'organId', '');
        $set(formObject.detail, 'postId', '');
        $set(formObject.detail, 'typeId', '');
      }
      this.formObject.detail.organPostId = value;
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    inputAmount: function inputAmount(value) {
      this.formObject.detail.totalAmount = Math.floor(value * 100) / 100;
      var number = Math.floor(value * 100) / 100;
      var ret = '';
      if (number !== '' && number != null && number !== '0') {
        var unit = '仟佰拾亿仟佰拾万仟佰拾元角分';
        var str = '';
        number += '00';
        var point = number.indexOf('.');
        if (point >= 0) {
          number = number.substring(0, point) + number.substr(point + 1, 2);
        }
        unit = unit.substr(unit.length - number.length);
        for (var i = 0; i < number.length; i++) {
          str += '零壹贰叁肆伍陆柒捌玖'.charAt(number.charAt(i)) + unit.charAt(i);
        }
        ret = str.replace(/零(仟|佰|拾|角)/g, '零').replace(/(零)+/g, '零').replace(/零(万|亿|元)/g, '$1').replace(/(亿)万|(拾)/g, '$1$2').replace(/^元零?|零分/g, '').replace(/元$/g, '元');
      }
      this.formObject.detail.totalAmountBig = ret;
    },
    /**
     * 返回列表页
     */
    goBack: function goBack() {
      this.$router.push({
        path: '/reimburseRepairs/myReimburse/list'
      });
    }
  }
};